// src/assets/icons/CustomIconsAdd4.js

import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

// --- SUBSCRIBE ICON ---
export const MenuSubscribe = (props) => (
  <SvgIcon {...props} viewBox='0 0 6.35 1.8521'>
    <rect
      x='.074654'
      y='.054693'
      width='6.1957'
      height='1.6953'
      ry='.44293'
      fill='#1565c0'
      stroke='#fff'
      strokeWidth='.001692'
    />
    <rect
      x='.48321'
      y='.37475'
      width='1.4981'
      height='.92593'
      ry='.26592'
      fill='#fff'
      stroke='#fff'
      strokeWidth='.0018141'
    />

    {/* NEW 3 SHAPES (Replaced the triangle) */}
    <g fill='#1565c0'>
      <rect
        x='.76899'
        y='.71891'
        width='.090407'
        height='.47068'
        ry='.015945'
        stroke='#000'
        strokeWidth='2.7773e-8'
      />
      <path
        d='m0.94777 0.72572 0.52322 7.8127e-4c0.030946-0.001045 0.029605 0.00564 0.026091 0.028511l-0.062307 0.40557c-0.00611 0.027326-0.014961 0.03716-0.033602 0.035191l-0.43405 1.958e-4c-0.026516-0.00292-0.034039 0.00812-0.03452-0.019405l5.915e-5 -0.43069c1.7141e-4 -0.016086 0.00143-0.02043 0.015107-0.020163z'
        strokeWidth='0'
      />
      <path
        d='m0.95992 0.73392 0.34452-0.28206c0.05063-0.033422 0.043833 0.022709 0.040874 0.054385l-0.019732 0.22606z'
        strokeWidth='0'
      />
    </g>

    <text
      x='2.2074521'
      y='1.0944754'
      fill='#ffffff'
      fontFamily="'Sans Serif Collection', sans-serif"
      fontSize='.82233px'
      letterSpacing='-0.02px'
      stroke='#ffffff'
      strokeWidth='.00077093'
      xmlSpace='preserve'>
      <tspan x='2.2074521' y='1.0944754' fill='#ffffff' strokeWidth='.00077093'>
        Subscribe
      </tspan>
    </text>
  </SvgIcon>
);

export const MENU_SUBSCRIBE_SVG_STRING = `<svg width="24" height="7" version="1.1" viewBox="0 0 6.35 1.8521" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"><rect x=".074654" y=".054693" width="6.1957" height="1.6953" ry=".44293" fill="#1565c0" stroke="#fff" stroke-width=".001692"/><rect x=".48321" y=".37475" width="1.4981" height=".92593" ry=".26592" fill="#fff" stroke="#fff" stroke-width=".0018141"/><g fill="#1565c0"><rect x=".76899" y=".71891" width=".090407" height=".47068" ry=".015945" stroke="#000" stroke-width="2.7773e-8"/><path d="m0.94777 0.72572 0.52322 7.8127e-4c0.030946-0.001045 0.029605 0.00564 0.026091 0.028511l-0.062307 0.40557c-0.00611 0.027326-0.014961 0.03716-0.033602 0.035191l-0.43405 1.958e-4c-0.026516-0.00292-0.034039 0.00812-0.03452-0.019405l5.915e-5 -0.43069c1.7141e-4 -0.016086 0.00143-0.02043 0.015107-0.020163z" stroke-width="0"/><path d="m0.95992 0.73392 0.34452-0.28206c0.05063-0.033422 0.043833 0.022709 0.040874 0.054385l-0.019732 0.22606z" stroke-width="0"/></g><text x="2.2074521" y="1.0944754" fill="#ffffff" font-family="'Sans Serif Collection', sans-serif" font-size=".82233px" letter-spacing="-0.02px" stroke="#ffffff" stroke-width=".00077093" xml:space="preserve"><tspan x="2.2074521" y="1.0944754" fill="#ffffff" stroke-width=".00077093">Subscribe</tspan></text></svg>`;

// --- RESET VIEW ICON ---
export const MenuResetView = (props) => (
  <SvgIcon {...props} viewBox='0 0 6.35 6.35'>
    <path
      d='m4.4614 4.629a2.2733 2.2733 0 0 1-2.8705 0.28272 2.2733 2.2733 0 0 1-0.83729-2.7602 2.2733 2.2733 0 0 1 2.5438-1.3597 2.2733 2.2733 0 0 1 1.8298 2.2297'
      fill='none'
      stroke='currentColor'
      strokeWidth='.76041'
    />
    <path
      transform='matrix(1.4247 0 0 1.0137 -1.4974 .50373)'
      d='m4.6629 3.621c-0.00669 0-0.67193-1.1522-0.66859-1.158 0.00334-0.00579 1.3338-0.00579 1.3372-1e-7 0.00334 0.00579-0.6619 1.158-0.66859 1.158z'
      stroke='currentColor'
      strokeWidth='.20639'
      fill='currentColor'
    />
  </SvgIcon>
);

// --- FULLY INTEGRATED REINSTATE ICON ---
export const MenuReinstate = ({
  iconScale = 6.5,
  iconX = 50,
  iconY = 50,
  textSize = '14px',
  textY = 82,
  label = 'Reinstate',
  ...props
}) => (
  <SvgIcon {...props} viewBox='0 0 100 120'>
    {/* -iconScale flips the arrow horizontally, internal -3.175 translates center the original graphic */}
    <g
      transform={`translate(${iconX}, ${iconY}) scale(-${iconScale}, ${iconScale}) translate(-3.175, -3.175)`}>
      <path
        d='m4.4614 4.629a2.2733 2.2733 0 0 1-2.8705 0.28272 2.2733 2.2733 0 0 1-0.83729-2.7602 2.2733 2.2733 0 0 1 2.5438-1.3597 2.2733 2.2733 0 0 1 1.8298 2.2297'
        fill='none'
        stroke='#333333'
        strokeWidth='.76041'
      />
      <path
        transform='matrix(1.4247 0 0 1.0137 -1.4974 .50373)'
        d='m4.6629 3.621c-0.00669 0-0.67193-1.1522-0.66859-1.158 0.00334-0.00579 1.3338-0.00579 1.3372-1e-7 0.00334 0.00579-0.6619 1.158-0.66859 1.158z'
        stroke='#333333'
        strokeWidth='.20639'
        fill='#333333'
      />
    </g>
    <text
      x='50'
      y={textY}
      fontFamily='Arial'
      fontSize={textSize}
      fontWeight='bold'
      fill='#333333'
      textAnchor='middle'>
      {label}
    </text>
  </SvgIcon>
);

export const MenuReinstateGrey = ({
  iconScale = 6.5,
  iconX = 50,
  iconY = 50,
  textSize = '14px',
  textY = 82,
  label = 'Reinstate',
  ...props
}) => (
  <SvgIcon {...props} viewBox='0 0 100 120'>
    {/* -iconScale flips the arrow horizontally, internal -3.175 translates center the original graphic */}
    <g
      transform={`translate(${iconX}, ${iconY}) scale(-${iconScale}, ${iconScale}) translate(-3.175, -3.175)`}>
      <path
        d='m4.4614 4.629a2.2733 2.2733 0 0 1-2.8705 0.28272 2.2733 2.2733 0 0 1-0.83729-2.7602 2.2733 2.2733 0 0 1 2.5438-1.3597 2.2733 2.2733 0 0 1 1.8298 2.2297'
        fill='none'
        stroke='#9e9e9e'
        strokeWidth='.76041'
      />
      <path
        transform='matrix(1.4247 0 0 1.0137 -1.4974 .50373)'
        d='m4.6629 3.621c-0.00669 0-0.67193-1.1522-0.66859-1.158 0.00334-0.00579 1.3338-0.00579 1.3372-1e-7 0.00334 0.00579-0.6619 1.158-0.66859 1.158z'
        stroke='#9e9e9e'
        strokeWidth='.20639'
        fill='#9e9e9e'
      />
    </g>
    <text
      x='50'
      y={textY}
      fontFamily='Arial'
      fontSize={textSize}
      fontWeight='normal'
      fill='#9e9e9e'
      textAnchor='middle'>
      {label}
    </text>
  </SvgIcon>
);

// --- UNARCHIVE ICON ---
export const MenuUnArchive = ({
  iconScale = 8,
  iconX = 50,
  iconY = 50, // <-- DECREASE this number to move the graphic UP (e.g., to 50)
  textSize = '14px',
  textY = 80, // <-- DECREASE this number to move the text UP (e.g., to 82)
  label = 'UnArchive',
  ...props
}) => (
  <SvgIcon {...props} viewBox='0 0 100 120'>
    <g
      transform={`translate(${iconX}, ${iconY}) scale(${iconScale}) translate(-3.175, -3.175)`}>
      <rect
        x='-.009858'
        y='5.1656'
        width='6.3782'
        height='1.183'
        fillOpacity='0'
        strokeWidth='.18521'
      />
      <path d='m3.1644-0.009858v6.4077' fillOpacity='0' strokeWidth='.18521' />
      <g transform='matrix(.022465 0 0 .021766 .62626 .33296)'>
        <rect x='9' y='62' width='207' height='150' rx='20' fill='#488ff7' />
        <rect
          transform='rotate(7.5,84,6)'
          x='84'
          y='6'
          width='110'
          height='122'
          rx='10'
          fill='#304056'
        />
        <rect
          transform='rotate(4.5,38,38)'
          x='38'
          y='38'
          width='132'
          height='100'
          rx='9'
          fill='#dbdbdb'
        />
        <path
          d='m8 108q0-26 22-28 82 18 165 0 22 2 22 28v90q0 20-20 20h-169q-20 0-20-20z'
          fill='#488ff7'
        />
        <rect x='119' y='166' width='77' height='34' rx='6' fill='#fff' />
        <g fill='none' stroke='#20242b' strokeLinecap='round' strokeWidth='4.5'>
          <line x1='129' x2='142' y1='176' y2='176' />
          <line x1='148' x2='171' y1='176' y2='176' />
          <line x1='176' x2='187' y1='176' y2='176' />
          <line x1='129' x2='150' y1='190' y2='190' />
          <line x1='157' x2='169' y1='190' y2='190' />
        </g>
        <g fill='none' stroke='#20242b' strokeLinecap='round' strokeWidth='5'>
          <line x1='73' x2='84' y1='62' y2='62' />
          <line x1='92' x2='161' y1='59' y2='63' />
          <line x1='73' x2='119' y1='78' y2='80' />
          <line x1='127' x2='161' y1='76' y2='79' />
        </g>
      </g>
      <g
        transform='matrix(.73199 0 0 .73199 2.715 -.02903)'
        fillOpacity='.50905'
        stroke='#fff'>
        <path d='m0.61743 5.9912v-3.9481' fill='#d3c931' strokeWidth='1.1896' />
        <path d='m-1.2551 3.5096 2.2098-2.2098' fill='#d3c931' strokeWidth='1.0583' />
        <path d='m2.462 3.5264-2.2098-2.2098' fill='#3181d3' strokeWidth='1.0583' />
      </g>
      <g
        transform='matrix(.69047 0 0 .69047 2.7408 .036112)'
        fillOpacity='.50905'
        stroke='#1400cd'>
        <path d='m0.61743 5.9912v-3.9481' fill='#d3c931' strokeWidth='1.1896' />
        <path d='m-1.2551 3.5096 2.2098-2.2098' fill='#d3c931' strokeWidth='1.0583' />
        <path d='m2.462 3.5264-2.2098-2.2098' fill='#3181d3' strokeWidth='1.0583' />
      </g>
    </g>
    <text
      x='50'
      y={textY}
      fontFamily='Arial'
      fontSize={textSize}
      fontWeight='bold'
      fill='#333333'
      textAnchor='middle'>
      {label}
    </text>
  </SvgIcon>
);

export const MenuUnArchiveGrey = ({
  iconScale = 8,
  iconX = 50,
  iconY = 50, // <-- MATCH the number above
  textSize = '14px',
  textY = 80, // <-- MATCH the number above
  label = 'UnArchive',
  ...props
}) => (
  <SvgIcon {...props} viewBox='0 0 100 120'>
    <g
      transform={`translate(${iconX}, ${iconY}) scale(${iconScale}) translate(-3.175, -3.175)`}>
      <rect
        x='-.009858'
        y='5.1656'
        width='6.3782'
        height='1.183'
        fillOpacity='0'
        strokeWidth='.18521'
      />
      <path d='m3.1644-0.009858v6.4077' fillOpacity='0' strokeWidth='.18521' />
      <g transform='matrix(.022465 0 0 .021766 .62626 .33296)'>
        <rect x='9' y='62' width='207' height='150' rx='20' fill='#9e9e9e' />
        <rect
          transform='rotate(7.5,84,6)'
          x='84'
          y='6'
          width='110'
          height='122'
          rx='10'
          fill='#757575'
        />
        <rect
          transform='rotate(4.5,38,38)'
          x='38'
          y='38'
          width='132'
          height='100'
          rx='9'
          fill='#e0e0e0'
        />
        <path
          d='m8 108q0-26 22-28 82 18 165 0 22 2 22 28v90q0 20-20 20h-169q-20 0-20-20z'
          fill='#9e9e9e'
        />
        <rect x='119' y='166' width='77' height='34' rx='6' fill='#ffffff' />
        <g fill='none' stroke='#616161' strokeLinecap='round' strokeWidth='4.5'>
          <line x1='129' x2='142' y1='176' y2='176' />
          <line x1='148' x2='171' y1='176' y2='176' />
          <line x1='176' x2='187' y1='176' y2='176' />
          <line x1='129' x2='150' y1='190' y2='190' />
          <line x1='157' x2='169' y1='190' y2='190' />
        </g>
        <g fill='none' stroke='#616161' strokeLinecap='round' strokeWidth='5'>
          <line x1='73' x2='84' y1='62' y2='62' />
          <line x1='92' x2='161' y1='59' y2='63' />
          <line x1='73' x2='119' y1='78' y2='80' />
          <line x1='127' x2='161' y1='76' y2='79' />
        </g>
      </g>
      <g
        transform='matrix(.73199 0 0 .73199 2.715 -.02903)'
        fillOpacity='.50905'
        stroke='#fff'>
        <path d='m0.61743 5.9912v-3.9481' fill='#bdbdbd' strokeWidth='1.1896' />
        <path d='m-1.2551 3.5096 2.2098-2.2098' fill='#bdbdbd' strokeWidth='1.0583' />
        <path d='m2.462 3.5264-2.2098-2.2098' fill='#9e9e9e' strokeWidth='1.0583' />
      </g>
      <g
        transform='matrix(.69047 0 0 .69047 2.7408 .036112)'
        fillOpacity='.50905'
        stroke='#757575'>
        <path d='m0.61743 5.9912v-3.9481' fill='#bdbdbd' strokeWidth='1.1896' />
        <path d='m-1.2551 3.5096 2.2098-2.2098' fill='#bdbdbd' strokeWidth='1.0583' />
        <path d='m2.462 3.5264-2.2098-2.2098' fill='#9e9e9e' strokeWidth='1.0583' />
      </g>
    </g>
    <text
      x='50'
      y={textY}
      fontFamily='Arial'
      fontSize={textSize}
      fontWeight='normal'
      fill='#9e9e9e'
      textAnchor='middle'>
      {label}
    </text>
  </SvgIcon>
);

// --- 5x5 GRID ICON ---
export const Grid5x5Icon = (props) => (
  <SvgIcon {...props} viewBox='0 0 24 24'>
    {[4, 8, 12, 16, 20].map((cy) =>
      [4, 8, 12, 16, 20].map((cx) => (
        <circle key={`${cx}-${cy}`} cx={cx} cy={cy} r='1' />
      )),
    )}
  </SvgIcon>
);

// --- MOVE FILE ICON ---
export const MenuMoveFile = ({
  iconScale = 0.08,
  iconX = 50,
  iconY = 60,
  textSize = '14px',
  textY = 95,
  label = 'Move Batch',
  ...props
}) => (
  <SvgIcon {...props} viewBox='0 0 100 120'>
    {/* Scale from original 512x512 viewbox, translating center (256) to origin */}
    <g
      transform={`translate(${iconX}, ${iconY}) scale(${iconScale}) translate(-256, -256)`}>
      <g
        transform='translate(-11.306 -.80757)'
        fill='none'
        stroke='#333333'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='26'>
        <path d='m150 48h-44q-26 0-26 26v370q0 26 26 26h44' />
        <path d='m166 48h212l92 92v304q0 26-26 26h-278q-26 0-26-26v-370q0-26 26-26z' />
        <path d='m378 48v92h92' />
        <path d='m205 270h173' />
        <path d='m335 225 63 45-63 45' />
      </g>
    </g>
    <text
      x='50'
      y={textY}
      fontFamily='Arial'
      fontSize={textSize}
      fontWeight='bold'
      fill='#333333'
      textAnchor='middle'>
      {label}
    </text>
  </SvgIcon>
);

export const MenuMoveFileGrey = ({
  iconScale = 0.08,
  iconX = 50,
  iconY = 60,
  textSize = '14px',
  textY = 95,
  label = 'Move Batch',
  ...props
}) => (
  <SvgIcon {...props} viewBox='0 0 100 120'>
    <g
      transform={`translate(${iconX}, ${iconY}) scale(${iconScale}) translate(-256, -256)`}>
      <g
        transform='translate(-11.306 -.80757)'
        fill='none'
        stroke='#9e9e9e'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='26'>
        <path d='m150 48h-44q-26 0-26 26v370q0 26 26 26h44' />
        <path d='m166 48h212l92 92v304q0 26-26 26h-278q-26 0-26-26v-370q0-26 26-26z' />
        <path d='m378 48v92h92' />
        <path d='m205 270h173' />
        <path d='m335 225 63 45-63 45' />
      </g>
    </g>
    <text
      x='50'
      y={textY}
      fontFamily='Arial'
      fontSize={textSize}
      fontWeight='normal'
      fill='#9e9e9e'
      textAnchor='middle'>
      {label}
    </text>
  </SvgIcon>
);

// --- ARCHIVE ICON ---
export const MenuArchive = ({
  iconScale = 8,
  iconX = 50,
  iconY = 63,
  textSize = '14px',
  textY = 95,
  label = 'Archive',
  ...props
}) => (
  <SvgIcon {...props} viewBox='0 0 100 120'>
    <g
      transform={`translate(${iconX}, ${iconY}) scale(${iconScale}) translate(-3.175, -3.175)`}>
      <rect
        x='-.009858'
        y='5.1656'
        width='6.3782'
        height='1.183'
        fillOpacity='0'
        strokeWidth='.18521'
      />
      <path d='m3.1644-0.009858v6.4077' fillOpacity='0' strokeWidth='.18521' />
      <g transform='matrix(.022465 0 0 .021766 .62626 .33296)'>
        <rect x='9' y='62' width='207' height='150' rx='20' fill='#488ff7' />
        <rect
          transform='rotate(7.5,84,6)'
          x='84'
          y='6'
          width='110'
          height='122'
          rx='10'
          fill='#304056'
        />
        <rect
          transform='rotate(4.5,38,38)'
          x='38'
          y='38'
          width='132'
          height='100'
          rx='9'
          fill='#dbdbdb'
        />
        <path
          d='m8 108q0-26 22-28 82 18 165 0 22 2 22 28v90q0 20-20 20h-169q-20 0-20-20z'
          fill='#488ff7'
        />
        <rect x='119' y='166' width='77' height='34' rx='6' fill='#fff' />
        <g fill='none' stroke='#20242b' strokeLinecap='round' strokeWidth='4.5'>
          <line x1='129' x2='142' y1='176' y2='176' />
          <line x1='148' x2='171' y1='176' y2='176' />
          <line x1='176' x2='187' y1='176' y2='176' />
          <line x1='129' x2='150' y1='190' y2='190' />
          <line x1='157' x2='169' y1='190' y2='190' />
        </g>
        <g fill='none' stroke='#20242b' strokeLinecap='round' strokeWidth='5'>
          <line x1='73' x2='84' y1='62' y2='62' />
          <line x1='92' x2='161' y1='59' y2='63' />
          <line x1='73' x2='119' y1='78' y2='80' />
          <line x1='127' x2='161' y1='76' y2='79' />
        </g>
      </g>
    </g>
    <text
      x='50'
      y={textY}
      fontFamily='Arial'
      fontSize={textSize}
      fontWeight='bold'
      fill='#333333'
      textAnchor='middle'>
      {label}
    </text>
  </SvgIcon>
);

export const MenuArchiveGrey = ({
  iconScale = 8,
  iconX = 50,
  iconY = 63,
  textSize = '14px',
  textY = 95,
  label = 'Archive',
  ...props
}) => (
  <SvgIcon {...props} viewBox='0 0 100 120'>
    <g
      transform={`translate(${iconX}, ${iconY}) scale(${iconScale}) translate(-3.175, -3.175)`}>
      <rect
        x='-.009858'
        y='5.1656'
        width='6.3782'
        height='1.183'
        fillOpacity='0'
        strokeWidth='.18521'
      />
      <path d='m3.1644-0.009858v6.4077' fillOpacity='0' strokeWidth='.18521' />
      <g transform='matrix(.022465 0 0 .021766 .62626 .33296)'>
        <rect x='9' y='62' width='207' height='150' rx='20' fill='#9e9e9e' />
        <rect
          transform='rotate(7.5,84,6)'
          x='84'
          y='6'
          width='110'
          height='122'
          rx='10'
          fill='#757575'
        />
        <rect
          transform='rotate(4.5,38,38)'
          x='38'
          y='38'
          width='132'
          height='100'
          rx='9'
          fill='#e0e0e0'
        />
        <path
          d='m8 108q0-26 22-28 82 18 165 0 22 2 22 28v90q0 20-20 20h-169q-20 0-20-20z'
          fill='#9e9e9e'
        />
        <rect x='119' y='166' width='77' height='34' rx='6' fill='#ffffff' />
        <g fill='none' stroke='#616161' strokeLinecap='round' strokeWidth='4.5'>
          <line x1='129' x2='142' y1='176' y2='176' />
          <line x1='148' x2='171' y1='176' y2='176' />
          <line x1='176' x2='187' y1='176' y2='176' />
          <line x1='129' x2='150' y1='190' y2='190' />
          <line x1='157' x2='169' y1='190' y2='190' />
        </g>
        <g fill='none' stroke='#616161' strokeLinecap='round' strokeWidth='5'>
          <line x1='73' x2='84' y1='62' y2='62' />
          <line x1='92' x2='161' y1='59' y2='63' />
          <line x1='73' x2='119' y1='78' y2='80' />
          <line x1='127' x2='161' y1='76' y2='79' />
        </g>
      </g>
    </g>
    <text
      x='50'
      y={textY}
      fontFamily='Arial'
      fontSize={textSize}
      fontWeight='normal'
      fill='#9e9e9e'
      textAnchor='middle'>
      {label}
    </text>
  </SvgIcon>
);

// --- NEW MENU VIEW ICON ---
export const MenuView = ({
  iconScale = 0.8,
  iconX = 50,
  iconY = 45,
  textSize = '18px',
  textY = 112,
  label = 'View',
  ...props
}) => (
  <SvgIcon {...props} viewBox='0 0 100 120'>
    <g
      transform={`translate(${iconX}, ${iconY}) scale(${iconScale}) translate(-50, -50)`}>
      <path
        d='M50 15C25 15 5 45 5 45s20 30 45 30 45-30 45-30-20-30-45-30zm0 50c-11.05 0-20-8.95-20-20s8.95-20 20-20 20 8.95 20 20-8.95 20-20 20zm0-32c-6.63 0-12 5.37-12 12s5.37 12 12 12 12-5.37 12-12-5.37-12-12-12z'
        fill='#2196f3'
      />
    </g>
    <text
      x='50'
      y={textY}
      fontFamily='Arial'
      fontSize={textSize}
      fontWeight='bold'
      fill='#333333'
      textAnchor='middle'
      style={{ opacity: props.sx?.opacity || 1 }}>
      {label}
    </text>
  </SvgIcon>
);

export const MenuViewGrey = ({
  iconScale = 0.8,
  iconX = 50,
  iconY = 45,
  textSize = '18px',
  textY = 112,
  label = 'View',
  ...props
}) => (
  <SvgIcon {...props} viewBox='0 0 100 120'>
    <g
      transform={`translate(${iconX}, ${iconY}) scale(${iconScale}) translate(-50, -50)`}>
      <path
        d='M50 15C25 15 5 45 5 45s20 30 45 30 45-30 45-30-20-30-45-30zm0 50c-11.05 0-20-8.95-20-20s8.95-20 20-20 20 8.95 20 20-8.95 20-20 20zm0-32c-6.63 0-12 5.37-12 12s5.37 12 12 12 12-5.37 12-12-5.37-12-12-12z'
        fill='#9e9e9e'
      />
    </g>
    <text
      x='50'
      y={textY}
      fontFamily='Arial'
      fontSize={textSize}
      fontWeight='normal'
      fill='#9e9e9e'
      textAnchor='middle'
      style={{ opacity: props.sx?.opacity || 1 }}>
      {label}
    </text>
  </SvgIcon>
);

// --- CREATE BATCH ICON (Clipboard with Plus Gear) ---
export const MenuCreateBatch = ({
  iconScale = 0.08,
  iconX = 50,
  iconY = 50,
  textSize = '14px',
  textY = 82,
  label = 'Create Batch',
  ...props
}) => (
  <SvgIcon {...props} viewBox='0 0 100 120'>
    <g
      transform={`translate(${iconX}, ${iconY}) scale(${iconScale}) translate(-256, -256)`}>
      {/* Clipboard Outline */}
      <path
        d='M 145,86 H 96 C 78,86 64,100 64,118 V 416 C 64,434 78,448 96,448 H 232'
        fill='none'
        stroke='#333333'
        strokeWidth='26'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M 335,86 H 384 C 402,86 416,100 416,118 V 256'
        fill='none'
        stroke='#333333'
        strokeWidth='26'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      {/* Clipboard Top Clip */}
      <rect x='172' y='44' width='136' height='64' rx='14' fill='#333333' />
      <rect x='214' y='24' width='52' height='28' rx='8' fill='#333333' />
      {/* Checklist Items */}
      <circle cx='140' cy='188' r='14' fill='#333333' />
      <line
        x1='184'
        y1='188'
        x2='332'
        y2='188'
        stroke='#333333'
        strokeWidth='26'
        strokeLinecap='round'
      />
      <circle cx='140' cy='260' r='14' fill='#333333' />
      <line
        x1='184'
        y1='260'
        x2='320'
        y2='260'
        stroke='#333333'
        strokeWidth='26'
        strokeLinecap='round'
      />
      <circle cx='140' cy='332' r='14' fill='#333333' />
      <line
        x1='184'
        y1='332'
        x2='250'
        y2='332'
        stroke='#333333'
        strokeWidth='26'
        strokeLinecap='round'
      />
      {/* Scalloped Badge & Plus Sign */}
      <g transform='translate(368, 392)'>
        <circle
          cx='0'
          cy='0'
          r='92'
          fill='#333333'
          stroke='#333333'
          strokeWidth='22'
          strokeDasharray='16 20.1'
          strokeLinejoin='round'
        />
        <circle cx='0' cy='0' r='86' fill='#333333' />
        <path
          d='M -38,0 H 38 M 0,-38 V 38'
          stroke='#ffffff'
          strokeWidth='28'
          strokeLinecap='round'
        />
      </g>
    </g>
    <text
      x='50'
      y={textY}
      fontFamily='Arial'
      fontSize={textSize}
      fontWeight='bold'
      fill='#333333'
      textAnchor='middle'>
      {label}
    </text>
  </SvgIcon>
);

export const MenuCreateBatchGrey = ({
  iconScale = 0.08,
  iconX = 50,
  iconY = 50,
  textSize = '14px',
  textY = 82,
  label = 'Create Batch',
  ...props
}) => (
  <SvgIcon {...props} viewBox='0 0 100 120'>
    <g
      transform={`translate(${iconX}, ${iconY}) scale(${iconScale}) translate(-256, -256)`}>
      {/* Clipboard Outline */}
      <path
        d='M 145,86 H 96 C 78,86 64,100 64,118 V 416 C 64,434 78,448 96,448 H 232'
        fill='none'
        stroke='#9e9e9e'
        strokeWidth='26'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M 335,86 H 384 C 402,86 416,100 416,118 V 256'
        fill='none'
        stroke='#9e9e9e'
        strokeWidth='26'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      {/* Clipboard Top Clip */}
      <rect x='172' y='44' width='136' height='64' rx='14' fill='#9e9e9e' />
      <rect x='214' y='24' width='52' height='28' rx='8' fill='#9e9e9e' />
      {/* Checklist Items */}
      <circle cx='140' cy='188' r='14' fill='#9e9e9e' />
      <line
        x1='184'
        y1='188'
        x2='332'
        y2='188'
        stroke='#9e9e9e'
        strokeWidth='26'
        strokeLinecap='round'
      />
      <circle cx='140' cy='260' r='14' fill='#9e9e9e' />
      <line
        x1='184'
        y1='260'
        x2='320'
        y2='260'
        stroke='#9e9e9e'
        strokeWidth='26'
        strokeLinecap='round'
      />
      <circle cx='140' cy='332' r='14' fill='#9e9e9e' />
      <line
        x1='184'
        y1='332'
        x2='250'
        y2='332'
        stroke='#9e9e9e'
        strokeWidth='26'
        strokeLinecap='round'
      />
      {/* Scalloped Badge & Plus Sign */}
      <g transform='translate(368, 392)'>
        <circle
          cx='0'
          cy='0'
          r='92'
          fill='#9e9e9e'
          stroke='#9e9e9e'
          strokeWidth='22'
          strokeDasharray='16 20.1'
          strokeLinejoin='round'
        />
        <circle cx='0' cy='0' r='86' fill='#9e9e9e' />
        <path
          d='M -38,0 H 38 M 0,-38 V 38'
          stroke='#ffffff'
          strokeWidth='28'
          strokeLinecap='round'
        />
      </g>
    </g>
    <text
      x='50'
      y={textY}
      fontFamily='Arial'
      fontSize={textSize}
      fontWeight='normal'
      fill='#9e9e9e'
      textAnchor='middle'>
      {label}
    </text>
  </SvgIcon>
);
